import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function NewsletterForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState(null);

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setErr("name");
      return;
    }
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!emailOk) {
      setErr("email");
      return;
    }
    setErr(null);
    try {
      const stored = JSON.parse(localStorage.getItem("zx_leads") || "[]");
      stored.push({ name: name.trim(), email: email.trim(), ts: Date.now() });
      localStorage.setItem("zx_leads", JSON.stringify(stored));
    } catch (_) {}
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className="grid grid-cols-1 gap-3 sm:grid-cols-2"
      noValidate
    >
      <div>
        <label
          htmlFor="nl-name"
          className="mb-1 block text-xs font-medium uppercase tracking-widest text-slate-300"
        >
          {t("newsletter.nameLabel")}
        </label>
        <input
          id="nl-name"
          data-testid="newsletter-name-input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("newsletter.namePlaceholder")}
          className="w-full rounded-md border border-slate-500 bg-white/5 px-4 py-3 text-sm text-white placeholder-slate-400 outline-none focus:border-[#C85A32]"
        />
      </div>
      <div>
        <label
          htmlFor="nl-email"
          className="mb-1 block text-xs font-medium uppercase tracking-widest text-slate-300"
        >
          {t("newsletter.emailLabel")}
        </label>
        <input
          id="nl-email"
          data-testid="newsletter-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("newsletter.emailPlaceholder")}
          className="w-full rounded-md border border-slate-500 bg-white/5 px-4 py-3 text-sm text-white placeholder-slate-400 outline-none focus:border-[#C85A32]"
        />
      </div>
      {err && (
        <p
          data-testid="newsletter-error"
          className="col-span-full text-sm font-medium text-[#F4A582]"
        >
          {err === "name" ? t("newsletter.errors.nameRequired") : t("newsletter.errors.emailRequired")}
        </p>
      )}
      <button
        type="submit"
        data-testid="newsletter-submit-btn"
        className="col-span-full mt-1 rounded-md bg-[#C85A32] px-6 py-3 text-sm font-semibold text-white hover:bg-[#B04D28]"
      >
        {t("newsletter.submit")}
      </button>
      <p className="col-span-full text-xs text-slate-400">
        {t("newsletter.consent")}
      </p>
    </form>
  );
}
